import React from 'react';
import { COMPANY_NAME } from '../constants';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-6xl mx-auto p-6 bg-white rounded shadow-md flex flex-col md:flex-row items-center md:items-start gap-6">
      <div className="md:w-1/2">
        <h2 className="text-3xl font-bold mb-4 text-gray-900">Privacy Policy</h2>
        <p className="mb-3 text-gray-700">
          At {COMPANY_NAME}, we are committed to protecting your privacy and ensuring the security of your personal information.
        </p>
        <p className="mb-3 text-gray-700">
          We comply with all applicable data protection laws and regulations.
        </p>
        <p className="mb-3 text-gray-700">
          We do not share your information with third parties without your consent.
        </p>
        <p className="mb-3 text-gray-700">
          For more details, please contact our support team.
        </p>
      </div>
      <div className="md:w-1/2">
        <img
          src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=80"
          alt="Privacy and Security"
          className="rounded shadow-md w-full h-auto object-cover"
        />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
